import { getInternetSecurityLinkQuery } from '../graphql/queries/multibss/internet-security.query';
import { ApiResponse, query } from './api';
import { InternetSecurityLink } from './internet-security.types';

interface InternetSecurityApi {
  internetSecurityLink(billingCustomerId: string, assignedProductId: string): ApiResponse<InternetSecurityLink>;
}

export const InternetSecurityApi: InternetSecurityApi = {
  internetSecurityLink(billingCustomerId: string, assignedProductId: string): ApiResponse<InternetSecurityLink> {
    return query<{ getInternetSecurityLink: InternetSecurityLink }>({
      query: getInternetSecurityLinkQuery,
      variables: { billingCustomerId, assignedProductId },
      name: 'getInternetSecurityLink',
    }).then(({ getInternetSecurityLink }) => ({ data: getInternetSecurityLink }));
  },
};
